import angular from 'angular';
import Model from './model';
import FactList from './fact-list';
import Trees from './trees';

function FactQueryFactory(Model, FactList, Trees) {
  return class FactQueryModel extends Model {
    constructor(data = {}) {
      super(data);

      this.setApi("/case/:caseId/query/:queryId", {
        caseId: '@caseId',
        queryId: '@id'
      }, {
        get: {
          method: 'GET',
          success: [data => this.setQuery(data)]
        },
        update: {
          method: 'PUT',
          success: [data => this.setQuery(data)],
          cancellable: true,
          url: "/user/case/:caseId/query/:queryId"
        },
        setViewBy: {
          params: {
            attribute: '@attribute'
          },
          url: "/case/:caseId/query/:queryId/viewby/:attribute",
          method: 'PUT',
          success: [
            data => this.setQuery(data)
          ]
        }
      });

    }
    setQuery(data) {
      if (FactList) {
        FactList.setData(data.factResult);
      }
      if (Trees) {
        Object.keys(data.valueTrees).forEach(key => {
          Trees[key].setData(data.valueTrees[key]);
          Trees[key].setExcludedByQuery(data.query.filterPipeline
            .filter(f => f.attribute === key)
            .shift()
          );
          Trees[key].setCollapsedByQuery(data.query.filterPipeline
            .filter(f => f.attribute === key)
            .shift()
          );
        });
      }
      this.setData(data.query);
    }
  }
}
FactQueryFactory.$inject = ['Model', 'FactList', 'Trees'];

export default angular.module('models.fact-query', [Model, FactList, Trees])
  .factory('FactQueryFactory', FactQueryFactory)
  .service('FactQuery', ['FactQueryFactory', FactQueryFactory => new FactQueryFactory()])
  .name;



// WEBPACK FOOTER //
// ./project/models/fact-query.js